Directives.HomeCardSetupGuide = function HomeCardSetupGuide() {

    // @ngInject
    function HomeCardSetupGuideControllerFunc($injector, $scope, HomeService, SetupGuideService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'HomeCardDirectiveController';
        this.HomeService = HomeService;
        this.SetupGuideService = SetupGuideService;

        this.isHomeForTrialer = this.HomeService.shouldShowHomeForTrialers();
    }

    var HomeCardSetupGuideController = Class(Controllers.BaseController, {
        constructor: HomeCardSetupGuideControllerFunc,
    });

    return {
        scope: {
          type: '@',
          goToView: '&',
          emptyState: '<',
          loading: '<'
        },
        templateUrl: 'angular/app/modules/core/features/home/home_card_setup_guide/home_card_setup_guide.html',
        controller: HomeCardSetupGuideController,
        controllerAs: 'homeCardSetupGuideVm',
        transclude: {
            'shimmer': '?homeCardShimmer'
        },
        bindToController: true
    };
};
